import React from 'react'
import { socialsParams } from '../block'
import ExternalSelect from '../components/ExternalSelect'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import Externals from './Externals'
import Menu from './Menu'
import Socials from './Socials'
import style from './style.module.scss'
import { menuItemParams } from '../../types'

type topHeaderParams = {
    menus: { instances: menuItemParams[]; top: menuItemParams[] }
    externals: { ticketting: string; myHand: string; handballTV: string; handHome: string }
    socials: socialsParams
}

const TopHeader: React.FC<topHeaderParams> = ({ menus, externals, socials }) => {
    const mobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')')

    if (mobile) {
        return null
    }

    return (
        <div className={style.top}>
            <div className={style.container}>
                <div className={style.col1}>
                    <ExternalSelect
                        placeholder={'instances'}
                        items={menus.instances}
                        color={style.blue100}
                    />
                    <Menu menu={menus.top} />
                </div>
                <div className={style.col2}>
                    <Externals externals={externals} />
                    <Socials socials={socials} />
                </div>
            </div>
        </div>
    )
}

export default TopHeader
